import r from "./_has.js";
import t from "./_toPath.js";
function o(o, a) {
  for (var f = (a = t(a)).length, e = 0; e < f; e++) {
    var n = a[e];
    if (!r(o, n)) return !1;
    o = o[n];
  }
  return !!f;
}
export { o as default };